import { useContext } from 'react';
import { AnalyticsContext } from '../../ModularReduxAnalytics';
import { useUser } from '../../state/user';
import { useApp, useAppDispatchers } from '../../state/app';
import VerifyFunding from '.';

const VerifyFundingContainer = ({ resolvesErrorId }) => {
  const { analytics } = useContext(AnalyticsContext);
  const {
    needsVerification,
    registrationToken,
    errorCode,
    error,
    message,
    loading
  } = useApp();
  const {
    getFundingAccounts,
    queryGetUser,
    getMicrodeposits,
    verifyDebitNow,
    createError,
    clearError,
    verifyDebitLater
  } = useAppDispatchers();
  const { funding, fundingAccounts, registeredUser } = useUser();
  const props = {
    analytics,
    needsVerification,
    funding,
    registrationToken,
    getFundingAccounts,
    queryGetUser,
    errorCode,
    fundingAccounts,
    registeredUser,
    getMicrodeposits,
    verifyDebitNow,
    createError,
    clearError,
    verifyDebitLater,
    verifyACHLater: verifyDebitLater,
    error,
    message,
    loading,
    resolvesErrorId
  };
  return <VerifyFunding {...props} />;
};

export default VerifyFundingContainer;
